import { FishInput } from '@app-graphql'

export type PendingFish = FishInput & {
    photoFileUri: string
    uploading?: boolean
}
